// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3g_Rv","header":"PatientQuestionnaire_header__109XJ","info":"PatientQuestionnaire_info__2UeR6"};